import { makeRequestAction } from './index';

export const fetchLenders = makeRequestAction('FETCH_LENDERS_WITH_CATEGORIES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
